module.exports = __webpack_public_path__ + "img/gestiondecitas.fd5a1e6a.png";